// extracted by mini-css-extract-plugin
module.exports = {"flight":"flight-2upgG","price":"price-319YQ","price__money":"price__money-3_ScE","currency":"currency-1U1Ix","stopPoint":"stopPoint-1RXg8"};